export default __webpack_public_path__ + "static/media/scheduling.6abe33c4.svg";